export const INITIAL_STATE = {
  donors: null,
  donorSearch: null,

  getAllDonorsLoading: false,
  getAllDonorsSuccess: null,
  getAllDonorsFailure: null,

  getDonorsLoading: false,
  getDonorsSuccess: null,
  getDonorsFailure: null,

  searchForDonorLoading: false,
  searchForDonorSuccess: null,
  searchForDonorFailure: null,

  registerDonorLoading: false,
  registerDonorSuccess: null,
  registerDonorFailure: null,

  registerGetDonorProfileLoading: null,
  registerGetDonorProfileSuccess: null,
  registerGetDonorProfileFailure: null,

  updateDonorLoading: false,
  updateDonorSuccess: null,
  updateDonorFailure: null,

  inquiryDonorLoading: false,
  inquiryDonorSuccess: null,
  inquiryDonorFailure: null,

  getDonorsPreferencesLoading: false,
  getDonorsPreferencesSuccess: null,
  getDonorsPreferencesFailure: null,
  lastPreferencesUpdate: +new Date(),

  updateDonorsPreferencesLoading: false,
  updateDonorsPreferencesSuccess: null,
  updateDonorsPreferencesFailure: null,

  getDonorLifetimeImpactLoading: false,
  getDonorLifetimeImpactSuccess: null,
  getDonorLifetimeImpactFailure: null,

  getDonorApcStatusLoading: false,
  getDonorApcStatusSuccess: null,
  getDonorApcStatusFailure: null,
  
  getDonorReferEarnedAmountLoading: false,
  getDonorReferEarnedAmountSuccess: null,
  getDonorReferEarnedAmountFailure: null
};
